import { application } from './application'
import { registerControllers } from 'stimulus-vite-helpers'
import AutoSubmit from '@stimulus-components/auto-submit'

const controllers = import.meta.glob('./**/*_controller.js', {eager: true})
registerControllers(application, controllers)
application.register('auto-submit', AutoSubmit)
